import React, {ReactNode, forwardRef} from 'react'
import classnames from 'classnames'

// @ts-ignore
import styles from './Checkbox.scss'

type CheckboxProps = JSX.IntrinsicElements['input'] & {
  children: ReactNode
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({children, ...inputProps}, ref) => (
  <label className={classnames(styles.checkboxContainer, {[styles.disabled]: inputProps.disabled})}>
    <input
      ref={ref}
      {...inputProps}
      type="checkbox"
      className={styles.checkboxInput}
    />
    <span className={styles.checkboxParts}>{children}</span>
  </label>
))
